module.exports = __webpack_public_path__ + "img/camera-reels.35c81d33.svg";